// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d3ny","label":"styles_label__wgKeb"};